import api from '../../../axios/axios-api'
import { mapPublicPortalApiToHospitalConfig } from '../../../utils/config/mapPublicPortalApiToHospitalConfig'

export default {
  async loadPublicConfig(context) {
    const { data } = await api.get('/config')
    const mapped = mapPublicPortalApiToHospitalConfig(data)
    context.commit('setHospitalConfig', mapped)
    context.commit('setLoadedFromApi', true)
  },
}
